export const ANXIETY_ASSESSMENT_RESULT = 'anxietyAssessmentResult';
export const ANXIETY_ASSESSMENT_SCORING = 'anxietyAssessmentScoring';
export const ANXIETY_ASSESSMENT_EMAIL = 'anxietyAssessmentEmail';
export const ADHD_ASSESSMENT_RESULT = 'assessmentResult';
export const ADHD_ASSESSMENT_EMAIL = 'assessmentEmail';
export const DEPRESSION_ASSESSMENT_RESULT = 'depressionAssessmentResult';
export const DEPRESSION_ASSESSMENT_SCORING = 'depressionAssessmentScoring';
export const DEPRESSION_ASSESSMENT_EMAIL = 'depressionAssessmentEmail';

export const BIPOLAR_ASSESSMENT_RESULT = 'bipolarAssessmentResult';
export const BIPOLAR_ASSESSMENT_EMAIL = 'bipolarAssessmentEmail';

export const WIDGET_ANXIETY_ASSESSMENT_RESULT = 'widgetAnxietyAssessmentResult';
export const WIDGET_DEPRESSION_ASSESSMENT_RESULT =
  'widgetDepressionAssessmentResult';
export const WIDGET_BIPOLAR_ASSESSMENT_RESULT = 'widgetBipolarAssessmentResult';
